import React from 'react';

import LinksPageLayout
  from 'components/dashboard/links-content/links-layout/LinksPageLayout';
import CryptoLinksPageContent
  from 'components/dashboard/crypto-links-content/CryptoLinksPageContent';


const DashboardCryptoLinksPage = () => (
  <LinksPageLayout activeLinksPage="crypto">
    <CryptoLinksPageContent />
  </LinksPageLayout>
);

export default DashboardCryptoLinksPage;
